"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPhenotypeImages = void 0;
const getPhenotypeImages = (skinTone, isMobile) => {
    const ImagesMobile = [
        `female_head_A-${skinTone}`,
        `female_head_C-${skinTone}`,
        `male_head_B-${skinTone}`,
        `male_head_A-${skinTone}`,
        `male_head_C-${skinTone}`,
        `female_head_B-${skinTone}`,
        `female_head_E-${skinTone}`,
        `male_head_D-${skinTone}`,
        `female_head_D-${skinTone}`,
        `male_head_E-${skinTone}`,
    ];
    const ImagesProductivity = [
        `female_head_A-${skinTone}`,
        `male_head_E-${skinTone}`,
        `female_head_C-${skinTone}`,
        `male_head_B-${skinTone}`,
        `female_head_D-${skinTone}`,
        `male_head_A-${skinTone}`,
        `female_head_E-${skinTone}`,
        `male_head_C-${skinTone}`,
        `female_head_B-${skinTone}`,
        `male_head_D-${skinTone}`,
    ];
    return isMobile ? ImagesMobile : ImagesProductivity;
};
exports.getPhenotypeImages = getPhenotypeImages;
